import AlignmentLeft from 'assets/icons/alignment-left.svg';
import AlignmentRight from 'assets/icons/alignment-right.svg';
import AlignmentCenter from 'assets/icons/alignment-middle.svg';
import AlignmentTop from 'assets/icons/alignment-top.svg';
import AlignmentBottom from 'assets/icons/alignment-bottom.svg';

import UploadCustomizer from 'assets/icons/adummy-icons/customizer-upload.svg';

export const toolbarTypes = {
  color: 'color',
  material: 'material',
  text: 'text',
  logo: 'logo',
  pattern: 'pattern',
  variant: 'variant',
  section: 'section',
};
export const floatingMenuType = {
  fontFamily: 'fontFamily',
  fontColor: 'fontColor',
  fontPosition: 'fontPosition',
  logoPlacement: 'logoPlacement',
  patternColor: 'patternColor',
  patternScaling: 'patternScaling',
};
export const showFloatingMenuType = {
  text: 'text',
  logo: 'logo',
  pattern: 'pattern',
};
export const fontSizeOptions = [
  { label: '12px', value: '12' },
  { label: '16px', value: '16' },
  { label: '18px', value: '18' },
  { label: '20px', value: '20' },
  { label: '22px', value: '22' },
  { label: '24px', value: '24' },
  { label: '50px', value: '50' },
  { label: '100px', value: '100' },
  { label: '150px', value: '150' },
];

export const textAlignments = [
  {
    id: '1',
    label: 'Left',
    value: {
      offsetX: -1, // aligned to left
      offsetY: 0, // aligned to top
    },
    src: AlignmentLeft,
  },
  {
    id: '1',
    label: 'Right',
    value: {
      offsetX: 1, // aligned to left
      offsetY: 0, // aligned to top
    },
    src: AlignmentRight,
  },
  {
    id: '1',
    label: 'Center',
    value: {
      offsetX: 0,
      offsetY: 0,
    },
    src: AlignmentCenter,
  },
  {
    id: '1',
    label: 'Top',
    value: {
      offsetX: 0,
      offsetY: 1,
    },
    src: AlignmentTop,
  },
  {
    id: '1',
    label: 'Bottom',
    value: {
      offsetX: 0,
      offsetY: -1,
    },
    src: AlignmentBottom,
  },
];
export const customizerIcons = {
  uploadCustomizer: UploadCustomizer,
};

export const OUTDATA_TYPE = {
  meshSelector: 'MESH_SELECTOR',
  zoneInfo: 'ZONE_INFO',
  decalItemSelected: 'DECAL_ITEM_SELECTED',
};

export const ZONE_ITEM_TYPE = {
  text: 'TEXT',
  image: 'IMAGE',
};

export const DEFAULT_FONT_COLOR = {
  fontColor: '#ff0000',
  outlineColor: '#ff0000',
};
